import { createContext } from 'react';

/** Lets month-view exercise rows open a popover editor without prop
 * drilling through MonthDayDroppableCell -> MonthDayContent ->
 * Draggable/ReadOnly item. The provider lives in MonthView and owns
 * which item is currently being edited. */
const MonthEditPopoverContext = createContext({
  openPopover: () => {},
  activeAssignedId: null,
  /** True only inside MonthView. Day/week consume the default (false) so
   * month-only behaviors (Shift+Click multi-select) stay scoped to month. */
  isMonthView: false,
});

export default MonthEditPopoverContext;
